export enum OperationTypeEnum {
    SendToMail = 'SendToMail',
    Downloaded = 'Downloaded'
}